import { trackInternalEvent } from '@rio/tracking'
import { useDispatch } from 'react-redux'
import { Icon32 } from 'builder/components/Icon'
import { useI18n } from 'builder/hooks/useI18n'
import { ButtonV2 } from 'builder/components/Button'
import { actions } from 'builder/modules/resumeEditor'
import { LoadingStatus } from '../../components/LoadingStatus/LoadingStatus'
import { JobPostingContainer, Title } from '../../styles'
import { JobPostingProps } from '../../types'
import { ListItem, List, Container, Content, ListIcon } from './styles'

const translationKey = 'builder.resume_optimizer.job_posting_for_editor_with_tabs.no_data_step'

export const NoDataStep = (props: JobPostingProps) => {
  const { children } = props
  const { i18n } = useI18n()
  const dispatch = useDispatch()

  const handleHighlightMissedData = () => {
    dispatch(actions.setEditorPanelType('editor'))
    dispatch(
      actions.highlightEmptyWorkExperience({
        title: i18n.t('builder.auto_tailoring.work_experience.title'),
        content: i18n.t('builder.auto_tailoring.work_experience.description'),
        buttonLabel: i18n.t('builder.auto_tailoring.work_experience.button_text'),
        delayMs: 500,
      }),
    )
    trackInternalEvent('click_continue', {
      label: 'auto_tailoring_missing_info_screen',
    })
  }

  return (
    <>
      <JobPostingContainer>
        <Container>
          <Content>
            <LoadingStatus
              title={i18n.t(`${translationKey}.status_text`)}
              icon={<Icon32.ArrowTarget />}
            />
            <Title>{i18n.t(`${translationKey}.title`)}</Title>
            <List>
              <ListItem>
                <ListIcon />
                {i18n.t(`${translationKey}.bullet_points.profile_summary`)}
              </ListItem>
              <ListItem>
                <ListIcon />
                {i18n.t(`${translationKey}.bullet_points.work_experience`)}
              </ListItem>
            </List>
          </Content>
          <ButtonV2 onClick={handleHighlightMissedData}>
            {i18n.t(`${translationKey}.button_text`)}
          </ButtonV2>
        </Container>
      </JobPostingContainer>
      {children}
    </>
  )
}
